export default __webpack_public_path__ + "static/media/SIW500H_W00.68160160.webp";